<a *ngIf="id && name" [routerLink]="['/battlescripts/forge', id]">{{ name }}</a>
